import { render, staticRenderFns } from "./SubjectLayout.vue?vue&type=template&id=6c9b6c69&scoped=true&"
import script from "./SubjectLayout.vue?vue&type=script&lang=js&"
export * from "./SubjectLayout.vue?vue&type=script&lang=js&"
import style0 from "./SubjectLayout.vue?vue&type=style&index=0&id=6c9b6c69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b6c69",
  null
  
)

export default component.exports